// @flow

import FormItem from 'components/FormList/FormItem'
import Loading from 'components/Loading'
import * as React from 'react'
import TableEmptyMessage from 'ui/table/TableEmptyMessage'

type Props = {
  handleItemClick?: (item: any) => void,
  isEmpty: boolean,
  isPacket: boolean,
  items: Array<any>,
  itemsAsLinks: boolean,
  loading: boolean,
  onPublicFormClick: (id: string, name: string, type: string) => void,
  onSelectResource: (id: string) => void,
  selectedResources: Array<any>,
  tabletMode: boolean,
  setLoading: (loading: boolean) => void,
}

function FormsPageFormListItems({
  handleItemClick,
  isEmpty,
  isPacket,
  items,
  itemsAsLinks,
  loading,
  onPublicFormClick,
  onSelectResource,
  selectedResources,
  tabletMode,
  setLoading,
}: Props): React.Node {
  if (loading) {
    return <Loading skipLogoutMessage fullHeight={false} />
  }

  if (isEmpty) {
    return <TableEmptyMessage>No Results Found</TableEmptyMessage>
  }

  return (
    <>
      {items.map((item) => (
        <FormItem
          asLink={itemsAsLinks}
          controlsDisabled={item.type === 'pdf'}
          enabled={item.enabled}
          handleItemClick={handleItemClick}
          handleSelectForm={onSelectResource}
          id={item.id}
          isInternalForm={item.is_internal_form}
          isPacket={isPacket}
          isSelected={Boolean(selectedResources?.find((i) => i.id === item.id))}
          item={item}
          key={item.id}
          measuresEnabled={item?.measure_enabled}
          name={item.name}
          onPublicFormClick={() =>
            onPublicFormClick(item.id, item.name, item.type)
          }
          setLoading={setLoading}
          tabletMode={tabletMode}
          type={item.type}
        />
      ))}
    </>
  )
}

export default FormsPageFormListItems
